import HeaderContainer from './header_container';

const Header = HeaderContainer;
export default Header;
